module.exports = __webpack_public_path__ + "img/appstore.bae7ab53.png";